
import { RouteRecordRaw } from 'vue-router';
/**
 * 定义404、401界面
 * @link 参考：https://next.router.vuejs.org/zh/guide/essentials/history-mode.html#netlify
 */
export const notFoundAndNoPower = [
	{
		path: '/:path(.*)*',
		name: 'notFound',
		component: () => import('@/views/error/404.vue'),
		meta: {
			title: 'message.staticRoutes.notFound',
			isHide: true,
		},
	},
	{
		path: '/401',
		name: 'noPower',
		component: () => import('@/views/error/401.vue'),
		meta: {
			title: 'message.staticRoutes.noPower',
			isHide: true,
		},
	}
];


/**
 * 定义静态路由（默认路由）
 * 此路由不要动，前端添加路由的话，请在 `dynamicRoutes 数组` 中添加
 * @description 前端控制直接改 dynamicRoutes 中的路由，后端控制不需要修改，请求接口路由数据时，会覆盖 dynamicRoutes 第一个顶级 children 的内容（全屏，不包含 layout 中的路由出口）
 * @returns 返回路由菜单数据
 */
export const staticRoutes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'layout',
		redirect: '/workbench',
		meta: {
			requiresAuth: true,
		},
		component: () => import('@/layout/index.vue'),
		children: [
			{
				path: '/achievements',
				name: 'achievements',
				component: () => import('@/views/teamManage/achievements.vue'),
			},
			{
				path: '/workbench',
				name: 'workbench',
				component: () => import('@/views/workbench/index.vue'),
			},
			{
				path: '/roleManage',
				name: 'roleManage',
				component: () => import('@/views/teamManage/roleManage.vue')
			},
			{
				path: '/department',
				name: 'department',
				component: () => import('@/views/teamManage/department.vue')
			},
			{
				path: '/store/list',
				name: 'store',
				component:() => import('@/views/store/list.vue')
			},
			{
				path: '/shopLibrary',
				name: 'shopLibrary',
				component:() => import('@/views/shopManage/shopLibrary.vue')
			},
			{
				path: '/sample',
				name: 'sample',
				component:() => import('@/views/sample/list.vue')
			},
			{
				path: '/order',
				name: 'order',
				component:() => import('@/views/orderManage/order.vue')
			},
			{
				path: '/myTalent',
				name: 'myTalent',
				component:() => import('@/views/talentCRM/myTalent.vue')
			},
			{
				path: '/cooperation',
				name: 'cooperation',
				component:() => import('@/views/channel/cooperation.vue')
			}, {
				path: '/emphasisTalent',
				name: 'emphasisTalent',
				component:() => import('@/views/talentCRM/emphasisTalent.vue')
			}, {
				path: '/groupSeas',
				name: 'groupSeas',
				component:() => import('@/views/talentCRM/groupSeas.vue')
			}, {
				path: '/followUpRecords',
				name: 'followUpRecords',
				component:() => import('@/views/talentCRM/followUpRecords.vue')
			}, {
				path: '/contacts',
				name: 'contacts',
				component:() => import('@/views/talentCRM/contacts.vue')
			}, {
				path: '/blacklist',
				name: 'blacklist',
				component:() => import('@/views/talentCRM/blacklist.vue')
			}, {
				path: '/clueSeas',
				name: 'clueSeas',
				component:() => import('@/views/talentCRM/clueSeas.vue')
			},
			{
				path: '/system/menu',
				name: 'menu',
				component:() => import('@/views/system/menu.vue')
			},
			{
				path: '/system/enumeration',
				name: 'enumeration',
				component:() => import('@/views/system/enumeration.vue')
			},
			{
				path: '/system/Account',
				name: 'Account',
				component:() => import('@/views/system/Account.vue')
			},
			{
				path: '/system/position',
				name: 'position',
				component:() => import('@/views/system/position.vue')
			},
			{
				path: '/system/tissue',
				name: 'tissue',
				component:() => import('@/views/system/tissue.vue')
			},
			{
				path: '/system/personnel',
				name: 'personnel',
				component:() => import('@/views/system/personnel.vue')
			},
			{
				path: '/SetManger',
				name: '/SetManger',
				component:() => import('@/views/SetManger/index.vue')
			},
			{
				path: '/labelManger',
				name: 'labelManger',
				component:() => import('@/views/labelManger/index.vue')
			},
			{
				path: '/user/manage',
				name: 'user',
				component:() => import('@/views/user/index.vue')

			},
			{
				path: '/whiteList',
				name: 'whiteList',
				component:() => import('@/views/talentCRM/whiteList.vue')
			},
			{
				path: '/personal/center',
				name: 'center',
				component: () => import('@/views/personal/center.vue'),
				children: [
					{
						path: '/personal/adPassword',
						name: 'teamManage',
						component: () => import('@/views/personal/adPassword.vue'),
					}
				]
			},
			{
				path: '/sample/returnSample',
				name: 'returnSample',
				component: () => import('@/views/sample/returnSample.vue'),
			},
			{
				path: '/systemMager/DictionaryManagement',
				name: 'DictionaryManagement',
				component: () => import('@/views/system/DictionaryManagement.vue'),
			},
			{
				path: '/pay-packages',
				name: 'pay-packages',
				component: () => import('@/views/pay/order.vue'),
			},
			{
				path: '/roilist',
				name: 'roi',
				component:() => import('@/views/roi/index.vue')
			}
		]
	},
	
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/login/index.vue'),
		meta: {
			title: '登录',
		},
	},

	
];
